module.exports = "./img/ce9588583bf3ec4f0634150aba4d4f1a.png";